/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Offline_Status_ConnectivityInputs */

const en_offline_status_connectivity = /** @type {(inputs: Offline_Status_ConnectivityInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Connectivity`)
};

const fr_offline_status_connectivity = /** @type {(inputs: Offline_Status_ConnectivityInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Connectivité`)
};

const de_offline_status_connectivity = /** @type {(inputs: Offline_Status_ConnectivityInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Konnektivität`)
};

const it_offline_status_connectivity = /** @type {(inputs: Offline_Status_ConnectivityInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Connettività`)
};

const ru_offline_status_connectivity = /** @type {(inputs: Offline_Status_ConnectivityInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Подключение`)
};

const es_offline_status_connectivity = /** @type {(inputs: Offline_Status_ConnectivityInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Conectividad`)
};

const zh_cn2_offline_status_connectivity = /** @type {(inputs: Offline_Status_ConnectivityInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`连接性`)
};

const ja_offline_status_connectivity = /** @type {(inputs: Offline_Status_ConnectivityInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`接続性`)
};

const hi_offline_status_connectivity = /** @type {(inputs: Offline_Status_ConnectivityInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`कनेक्टिविटी`)
};

const pt_pt2_offline_status_connectivity = /** @type {(inputs: Offline_Status_ConnectivityInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Conectividade`)
};

/**
* | output |
* | --- |
* | "Connectivity" |
*
* @param {Offline_Status_ConnectivityInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const offline_status_connectivity = /** @type {((inputs?: Offline_Status_ConnectivityInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Offline_Status_ConnectivityInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_offline_status_connectivity(inputs)
	if (locale === "de") return de_offline_status_connectivity(inputs)
	if (locale === "it") return it_offline_status_connectivity(inputs)
	if (locale === "ru") return ru_offline_status_connectivity(inputs)
	if (locale === "es") return es_offline_status_connectivity(inputs)
	if (locale === "zh-CN") return zh_cn2_offline_status_connectivity(inputs)
	if (locale === "ja") return ja_offline_status_connectivity(inputs)
	if (locale === "hi") return hi_offline_status_connectivity(inputs)
	if (locale === "pt-PT") return pt_pt2_offline_status_connectivity(inputs)
	return en_offline_status_connectivity(inputs)
});